export function extractInstagramUsername(url) {
  if (!url) return null
  if (!url.includes('/')) return null

  try {
    const { pathname } = new URL(url)
    const segments = pathname.split('/').filter(Boolean)
    return segments[0] || null
  } catch (err) {
    console.error('Invalid URL:', url)
    return null
  }
}
